<template>
  <section class="share--page" v-if="show">
    <van-overlay :show="show" @click="closeShare" z-index='2'/>
    <!-- <img src="@/assets/share-icon.png" alt="" class="share__icon"> -->
    <img :src="poster" alt="" class="share__poster">
    <p class="share__text">长按保存新年签<br>呼唤好友一起领红包吧<br>或点击右上角呼唤哦～</p>
  </section>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    poster: {
      type: String
    }
  },
  methods: {
    closeShare () {
      this.$emit('closeShare')
    }
  }
}
</script>

<style lang="scss">
.share--page{
  .share__poster{
    position: absolute;
    top: 123px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 3;
    width: 414px;
  }
  .share__text{
    position: absolute;
    top: 895px;
    width: 100vw;
    z-index: 3;
    text-align: center;
    font-size:28px;
    font-family:Source Han Sans CN;
    font-weight:400;
    line-height: 58px;
    color:rgba(255,234,213,1);
  }
}
</style>